import React from 'react'
import { NavLink } from 'react-router-dom'
import './Navbar.css'

function Navbar({ navBarClassName, navBarClassNameOption, navLinkClassName }) {
  return (
    <div className={navBarClassName}>
      <NavLink to='/products' className={navLinkClassName}>
        <span className={navBarClassNameOption}>Our Products</span>
      </NavLink>
      <NavLink to='/about' className={navLinkClassName}>
        <span className={navBarClassNameOption}>About Us</span>
      </NavLink>

      <NavLink to='/contact' className={navLinkClassName}>
        <span className={navBarClassNameOption}>Contact</span>
      </NavLink>
    </div>
  )
}

export default Navbar
